import { render } from "./PickUpAddress.vue?vue&type=template&id=6b2cd1e2"
import script from "./PickUpAddress.vue?vue&type=script&lang=js"
export * from "./PickUpAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__